import {
  Cog,
  Monitor,
  Network,
  Server,
  Timer,
  type LucideIcon,
} from 'lucide-react';

const EXACT: Record<string, LucideIcon> = {
  gateway: Network,
  temporal_server_api: Timer,
  orchestration_worker_api: Cog,
};

export function getServiceIcon(id: string): LucideIcon {
  if (EXACT[id]) return EXACT[id];
  if (id.includes('worker')) return Cog;
  if (id.includes('temporal')) return Timer;
  if (id.endsWith('_fo') || id.includes('_fo_')) return Monitor;
  if (id.endsWith('_api') || id.includes('_api_')) return Server;
  if (id.includes('gateway')) return Network;
  return Server;
}

export function humanizeServiceId(id: string): string {
  return id
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export type ServiceGroup = 'api' | 'fo' | 'infra' | 'other';

export function getServiceGroup(id: string): ServiceGroup {
  if (id.endsWith('_fo') || id.includes('_fo_')) return 'fo';
  if (id.includes('temporal') || id.includes('worker') || id === 'gateway') return 'infra';
  if (id.endsWith('_api') || id.includes('_api_')) return 'api';
  return 'other';
}
